<div [formGroup]="form">
    <div class="form-check">
        <input mdbCheckbox class="form-check-input" type="checkbox" [id]="checkBoxId"  (change)="change($event)"/>
        <label class="form-check-label" [for]="checkBoxId">
            {{checkBoxLabel}}
        </label>
    </div>
</div>